module.exports = __webpack_public_path__ + "img/RF-Cards.a0a24afe.png";